import Full from './full.vue';
import MobFull from './mobfull.vue';

export const componentMap = {
	full: Full,
	'mob-full': MobFull
};